import development from './config/development';
import staging from './config/staging';
import uat from './config/uat';
import production from './config/production';

const config = {
  development,
  staging,
  uat,
  production,
};

export default config[process.env.REACT_APP_BUILD_ENV || process.env.NODE_ENV];
